type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`max-w-3xl ${isCenter ? "mx-auto text-center" : ""}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc ? <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">{desc}</p> : null}
    </div>
  );
}